import { ThemeProvider as NextThemesProvider } from 'next-themes'
import type { ComponentProps } from 'react'

/**
 * App-wide theme provider (light / dark / system).
 *
 * Pairs with the no-flash inline script in index.html and the `.dark` token
 * set in index.css. `attribute="class"` toggles the `dark` class on <html>,
 * which Tailwind's `darkMode: ['class']` keys off.
 */
export function ThemeProvider({
  children,
  ...props
}: ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}
